module.exports = __webpack_public_path__ + "static/media/bg1.73160335.jpg";